// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"25dfa3cd","455":"4071f462","666":"a7526805","977":"4aa16f4e"}[chunkId] + ".chunk.js";
};